@import "../../../globalStyles/commons";
@import "../pie/pie";

:host {
  display: inline-block;
}

